import { useTranslation } from "react-i18next";
import { useOrganization } from "./use-organization";

export function useRevokePeriod() {
  const { t } = useTranslation();
  const { data: organization } = useOrganization();
  const revokePeriodDays = organization?.revokePeriod ?? 14;

  const isWithinRevokePeriod = (startAt: Date | null | undefined | string) => {
    if (!startAt || typeof startAt === "string") {
      return false;
    }
    return startAt.getTime() - new Date().getTime() > revokePeriodDays * 24 * 60 * 60 * 1000;
  };

  const getRevokePeriodText = () => {
    if (revokePeriodDays === 0) {
      return t("common:revoke-period.before-shift-starts");
    }
    if (revokePeriodDays <= 3) {
      const hours = revokePeriodDays * 24;
      return t("common:revoke-period.hours-before", { hours });
    }
    return t("common:revoke-period.days-before", { days: revokePeriodDays });
  };

  return {
    revokePeriodDays,
    isWithinRevokePeriod,
    getRevokePeriodText,
  };
}
